import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const login = async (user) => {
  const response = await axios.post(`${base_url}user/admin-login`, user);
  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

const getOrders = async () => {
  const response = await axios.get(`${base_url}user/getallorders`, config);

  return response.data;
};

const getUnreadOrders = async () => {
  const response = await axios.get(`${base_url}user/getunreadorders`, config);
  return response.data;
};

const getOrder = async (id) => {
  const response = await axios.get(
    `${base_url}user/getaOrder/${id}`,
    config
  );
  return response.data;
};

const markOrderAsViewed = async (data) => {
  const response = await axios.put(
    `${base_url}user/order/${data.id}/viewed`,
    {},
    config
  );
  return response.data;
};

const updateOrder = async (data) => {
  const response = await axios.put(
    `${base_url}user/updateOrder/${data.id}`, {status:data?.status},
    config
  );

  return response.data;
};

const getMonthlyOrders = async (data) => {
  const response = await axios.get(
    `${base_url}user/getMonthWiseOrderIncome`,
    data
  );

  return response.data;
};

const getAllPayments = async () => {
  try {
    const response = await axios.get(`${base_url}user/payments`,config);
    console.log("Data received from backend:", response.data); // Log the data
    return response.data;
  } catch (error) {
    console.error("Error fetching payments:", error);
    throw error;
  }
};



const getYearlyStats = async (data) => {

    const response = await axios.get(
      `${base_url}user/getyearlyorders`,
      data
    );
  
    return response.data;

};
const authService = {
  login,
  getOrders,
  getOrder,
  getMonthlyOrders,
  getYearlyStats,
  updateOrder,
  getAllPayments,
  markOrderAsViewed,
  getUnreadOrders,
};

export default authService;
